import {desktopDto} from '@vectronic/desktop-api'
import {webDtos as adminWebDtos, dsDtos, userDtos} from '@vectronic/openApi-admin'
import {webDtos as customerWebDtos} from '@vectronic/openApi-customer'
import {_ItemHelpGeneric as ItemHelp} from './item.help.generic'

export enum _ItemGeneric {
  ANIMAL = 'animal',
  COLLAR = 'collar',
  TRAP = 'trap',
  DROP_OFF = 'dropOff',
  EXTERNAL_SENSOR = 'externalSensor',
  CAMERA = 'camera',
  CONFIGURATION_DEVICE = 'configurationDevice',
  DATA_LOGGER = 'dataLogger',
  TT4_SENSOR = 'tt4Sensor',
  ANIMAL_GROUP = 'animalGroup',
  COLLAR_GROUP = 'collarGroup',
  TRAP_GROUP = 'trapGroup',
}

export type _DeviceItemGeneric = ReturnType<typeof ItemHelp.device>[number]
export type _SingleItemGeneric = ReturnType<typeof ItemHelp.single>[number]
export type _GroupItemGeneric = ReturnType<typeof ItemHelp.group>[number]
export type _MemberItemGeneric = ReturnType<typeof ItemHelp.member>[number]
export type _RegisterItemGeneric = ReturnType<typeof ItemHelp.register>[number]
export type _DeployItemGeneric = ReturnType<typeof ItemHelp.deploy>[number]
export type _TreeviewItemGeneric = ReturnType<typeof ItemHelp.treeview>[number]

export type _ToStringItemGeneric<T extends _ItemGeneric> = `${T}`

export type _ToDeployPartnerItemGeneric<T extends _DeployItemGeneric> = T extends _ItemGeneric.ANIMAL
  ? _ItemGeneric.COLLAR
  : _ItemGeneric.ANIMAL

export type _ToMemberItemGeneric<T extends _GroupItemGeneric> = T extends _ItemGeneric.ANIMAL_GROUP
  ? _ItemGeneric.ANIMAL
  : T extends _ItemGeneric.COLLAR_GROUP
    ? _ItemGeneric.COLLAR
    : T extends _ItemGeneric.TRAP_GROUP
      ? _ItemGeneric.TRAP
      : unknown

export type _ToGroupItemGeneric<T extends _MemberItemGeneric> = T extends _ItemGeneric.ANIMAL
  ? _ItemGeneric.ANIMAL_GROUP
  : T extends _ItemGeneric.COLLAR
    ? _ItemGeneric.COLLAR_GROUP
    : T extends _ItemGeneric.TRAP
      ? _ItemGeneric.TRAP_GROUP
      : unknown

export type _ToAddItemDtoGeneric<T extends _ItemGeneric> = T extends _RegisterItemGeneric
  ? _RegisterToDtoGeneric<T>
  : T extends _ItemGeneric
    ? _ItemToCustomerWebDtoGeneric<T>
    : unknown

export type _ItemToDsDtoGeneric<T extends _DeviceItemGeneric> = T extends _ItemGeneric.COLLAR
  ? dsDtos.Collar
  : T extends _ItemGeneric.CAMERA
    ? dsDtos.Camera
    : T extends _ItemGeneric.CONFIGURATION_DEVICE
      ? dsDtos.ConfigurationDevice
      : T extends _ItemGeneric.DATA_LOGGER
        ? dsDtos.DataLogger
        : T extends _ItemGeneric.DROP_OFF
          ? dsDtos.DropOff
          : T extends _ItemGeneric.EXTERNAL_SENSOR
            ? dsDtos.ExternalSensor
            : T extends _ItemGeneric.TT4_SENSOR
              ? dsDtos.TT4Sensor
              : unknown

export type _ItemToUserDtoGeneric<T extends _ItemGeneric> = T extends _ItemGeneric.ANIMAL
  ? userDtos.Animal
  : T extends _ItemGeneric.COLLAR
    ? userDtos.Collar
    : T extends
          | _ItemGeneric.TRAP
          | _ItemGeneric.CAMERA
          | _ItemGeneric.CONFIGURATION_DEVICE
          | _ItemGeneric.DATA_LOGGER
          | _ItemGeneric.DROP_OFF
          | _ItemGeneric.EXTERNAL_SENSOR
          | _ItemGeneric.TT4_SENSOR
      ? userDtos.Shareable
      : T extends _GroupItemGeneric
        ? userDtos.Group
        : unknown

export type _ItemToCustomerWebDtoGeneric<T extends _ItemGeneric> = T extends _DeviceItemGeneric
  ? _DeviceToCustomerWebDtoGeneric<T>
  : T extends _ItemGeneric.ANIMAL
    ? customerWebDtos.AnimalExtended
    : T extends _GroupItemGeneric
      ? customerWebDtos.Group
      : unknown

type _DeviceToCustomerWebDtoGeneric<T extends _DeviceItemGeneric> = T extends _ItemGeneric.COLLAR
  ? customerWebDtos.CollarExtended
  : T extends _ItemGeneric.TRAP
    ? customerWebDtos.TrapExtended
    : T extends _ItemGeneric.DROP_OFF
      ? customerWebDtos.DropOffExtended
      : T extends
            | _ItemGeneric.CAMERA
            | _ItemGeneric.CONFIGURATION_DEVICE
            | _ItemGeneric.DATA_LOGGER
            | _ItemGeneric.EXTERNAL_SENSOR
            | _ItemGeneric.TT4_SENSOR
        ? customerWebDtos.Device
        : unknown

export type DeviceToDesktopDtoGeneric<T extends _DeviceItemGeneric> = T extends _ItemGeneric.COLLAR
  ? desktopDto.Collar
  : T extends _ItemGeneric.TRAP
    ? desktopDto.Trap
    : T extends
          | _ItemGeneric.CAMERA
          | _ItemGeneric.CONFIGURATION_DEVICE
          | _ItemGeneric.DATA_LOGGER
          | _ItemGeneric.DROP_OFF
          | _ItemGeneric.EXTERNAL_SENSOR
          | _ItemGeneric.TT4_SENSOR
      ? desktopDto.Device
      : unknown

export type _DeviceToAdminWebDtoGeneric<T extends _DeviceItemGeneric> = T extends _ItemGeneric.COLLAR
  ? adminWebDtos.CollarAdmin
  : T extends _ItemGeneric.TRAP
    ? adminWebDtos.LongRangeDeviceAdmin
    : T extends _ItemGeneric.CAMERA
      ? adminWebDtos.CameraAdmin
      : T extends _ItemGeneric.CONFIGURATION_DEVICE
        ? adminWebDtos.DeviceAdmin
        : T extends _ItemGeneric.DATA_LOGGER
          ? adminWebDtos.DeviceAdmin
          : T extends _ItemGeneric.DROP_OFF
            ? adminWebDtos.DropOffAdmin
            : T extends _ItemGeneric.EXTERNAL_SENSOR
              ? adminWebDtos.ExternalSensorAdmin
              : T extends _ItemGeneric.TT4_SENSOR
                ? adminWebDtos.TT4SensorAdmin
                : unknown

export type _RegisterToDtoGeneric<T extends _RegisterItemGeneric> = T extends _ItemGeneric.COLLAR
  ? customerWebDtos.RegisterCollar
  : T extends _ItemGeneric.TRAP
    ? customerWebDtos.RegisterTrap
    : unknown
